import React from "react";

type Props = {
  title?: string;
};

export const TeamLayout: React.FC<Props> = ({
  children,
  title = "Team Organization",
}) => {
  return (
    <div className={"mb-[120px] py-6"}>
      <div
        className={"mb-6 flex items-center justify-between gap-4 font-Manrope"}>
        <div className={"text-2xl font-semibold"}>{title}</div>
      </div>

      {children}
    </div>
  );
};
